module.exports = __webpack_public_path__ + "static/media/company2Text.ff8a509b.png";